import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const ITEM_HEIGHT = 48;

const UsersEditMenuButton = (props) => {
    const { params, setShowDeleteDialog, setShowEditDialog, setCurrentSelectedUser, isActive, canImpersonate, onImpersonate } = props;
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const onEditClick = (e) => {
        e.stopPropagation(); // don't select this row after clicking

        setCurrentSelectedUser(params.row);
        setShowEditDialog(true);
        handleClose();
    };

    const onDeleteClick = (e) => {
        e.stopPropagation(); // don't select this row after clicking

        setCurrentSelectedUser(params.row);
        setShowDeleteDialog(true);
        handleClose();
    };

    const onImpersonateClick = (e) => {
        e.stopPropagation(); // don't select this row after clicking

        onImpersonate(params.row);
        handleClose();
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    return <div>
        <IconButton
            aria-label="more"
            id="long-button"
            aria-controls={open ? 'long-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="true"
            onClick={handleClick}
        >
            <MoreVertIcon />
        </IconButton>
        <Menu
            id="long-menu"
            MenuListProps={{
                'aria-labelledby': 'long-button',
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            PaperProps={{
                style: {
                    maxHeight: ITEM_HEIGHT * 4.5,
                    width: '20ch',
                },
            }}
        >

            <MenuItem key={1} onClick={(e) => {
                onEditClick(e);
            }}>
                {t('common.edit')}
            </MenuItem>
            <MenuItem key={2} onClick={(e) => {
                onDeleteClick(e);
            }}>
                {isActive ? t('usersEditMenu.deactivate') : t('usersEditMenu.activate') }
            </MenuItem>
            {canImpersonate &&
                <MenuItem key={3} onClick={(e) => {
                    onImpersonateClick(e);
                }}>
                    {t('usersEditMenu.impersonate')}
                </MenuItem>
            }

        </Menu>
    </div>;
};

UsersEditMenuButton.propTypes = {
    setShowDeleteDialog: PropTypes.func.isRequired,
    setShowEditDialog: PropTypes.func.isRequired,
    setCurrentSelectedUser: PropTypes.func.isRequired,
    isActive: PropTypes.bool.isRequired,
    params: PropTypes.object.isRequired,
    canImpersonate: PropTypes.bool,
    onImpersonate: PropTypes.func,
};

UsersEditMenuButton.defaultProps = {
    canImpersonate: false,
    onImpersonate: () => {},
};
export default UsersEditMenuButton;
